import React from "react";
import { useTranslation } from "react-i18next";
import { Game } from "@nestcoinco/hyper-api-gateway-api-client";

import ImageFallbackThumbnail from "../../../images/fallback-thumbnail.png";
import useInfinitePopularGamesQuery from "../../../react-query/queries/use-infinite-popular-games";

interface MoreGameCardProps {
  game: Game;
  onSelect: (slug: string) => void;
}

function MoreGameCard({ game, onSelect }: MoreGameCardProps) {
  return (
    <button
      type="button"
      className="more-game-card"
      onClick={() => onSelect(game.slug!)}
    >
      <img
        src={game.thumbnail || game.poster || ImageFallbackThumbnail}
        alt=""
        className="more-game-image"
        onError={(event) => {
          event.currentTarget.onerror = null;
          event.currentTarget.src = ImageFallbackThumbnail;
        }}
      />
      <p className="more-game-name">{game.name}</p>
    </button>
  );
}

interface MoreGamesSectionProps {
  onSelectGame: (slug: string) => void;
  onViewMore: () => void;
}

export default function MoreGamesSection({
  onSelectGame,
  onViewMore,
}: MoreGamesSectionProps) {
  const { t } = useTranslation("games");
  const { popularGames } = useInfinitePopularGamesQuery({ limit: 10 });

  if (!popularGames.length) return null;

  return (
    <section className="more-games">
      <div className="more-games-header">
        <h2 className="more-games-title">
          {t("game_landing.more_games_to_play")}
        </h2>
        <button
          type="button"
          className="more-games-view-more"
          onClick={onViewMore}
        >
          {t("view_more")}
        </button>
      </div>
      <div className="more-games-rail">
        {popularGames.map(({ game }) => (
          <MoreGameCard
            key={game.id ?? game.slug}
            game={game}
            onSelect={onSelectGame}
          />
        ))}
      </div>
    </section>
  );
}
